import "./recordBox.css";
import { useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import RecordComplex from "../recordComplex/RecordComplex";
import RecordComplexWithAssign from "../recordComplexWithAssign/RecordComplexWithAssign";
import { renderRecordTitles } from "../../util/basicRenders";
import { isScrolledIntoView } from "../../util/elementHelpers";
import { useDispatch } from "react-redux";
import { hideSeeLessButton, showSeeLessButton } from "../../store/recordTables/actions";
export const RecordBox = props => {
  //props
  const obligations = props?.obligations ?? [];
  const user = props?.user ?? {};
  const numberOfLessObligationsToShow =
    props?.numberOfLessObligationsToShow ?? 1;
  const page = props.page?.replace(" ", "-") ?? "";
  const identifier = props?.id?.replace(" ", "-") ?? uuidv4();
  const title = props?.title ?? "Records";
  const type = props?.type ?? "default";
  const usersData = props.usersData ?? "";
  const [showMore, setShowMore] = useState(false);
  const [itemsToShow, setItemsToShow] = useState(numberOfLessObligationsToShow);
  const dispatch = useDispatch();

  const seeLessElement = document.getElementById(`record-box-${identifier}`);
  const visibleShowLessButton = showMore ? isScrolledIntoView(seeLessElement) : showMore;
  //pocket

  //behaviours
  const handleScroll = (event, target) => {
    event.preventDefault();
    event.stopPropagation();
    // console.debug("scroll", event.deltaY);
    if (event.deltaY > 3) {
      setItemsToShow(Math.min(itemsToShow + 1, obligations.length));
    }
    if (event.deltaY < -3) {
      setItemsToShow(
        Math.max(itemsToShow - 1, numberOfLessObligationsToShow + 1)
      );
    }
  };

  const handleClick = () => {
    const showLessButtonClicked = showMore; //describes if Show Less Button was the one clicked by getting the showMore value before it is changed after the click action
    setShowMore(!showMore);
    const targetElement = document.getElementById(`record-box-${identifier}`);

    if (targetElement && showLessButtonClicked) {
      setItemsToShow(numberOfLessObligationsToShow)
      const { top } = targetElement.getBoundingClientRect();

      // dispatch(hideSeeLessButton());

      window.scrollTo({
        top: window.scrollY / 1.1 + top,
        behavior: "smooth"
      });
      // targetElement.removeEventListener("wheel", event => {});
      // targetElement.addEventListener(
      //   "wheel",
      //   event => handleScroll(event, targetElement),
      //   { passive: true }
      // );
    }
    if (targetElement && !showLessButtonClicked) {
      // setItemsToShow(numberOfLessObligationsToShow + 1);
      setItemsToShow(obligations.length);

      // dispatch(showSeeLessButton(identifier))

      targetElement.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest"
      });
      // targetElement.removeEventListener(
      //   "wheel",
      //   event => handleScroll(event, targetElement),
      //   { passive: false }
      // );
    }
  };

  //this was supposed to return the box footer at the bottom of the page on every itemsToShow change 
  // useEffect(() => {
  //   if (itemsToShow >= numberOfLessObligationsToShow) {
  //     const targetElement = document.getElementById(`record-box-${identifier}`);
  //     if (targetElement) {
  //       targetElement.scrollIntoView({
  //         behavior: "smooth",
  //         block: "end",
  //         inline: "nearest"
  //       });
  //     }
  //   }
  // }, [itemsToShow, identifier, numberOfLessObligationsToShow]);

  // hide float button if see less component button is visible
  // useEffect(() => {
  //   if (identifier) {
  //     if (visibleShowLessButton) {
  //       dispatch(hideSeeLessButton());
  //     }
  //     else {
  //       dispatch(showSeeLessButton(identifier))
  //     }
  //   }
  // }, [visibleShowLessButton, identifier ])

  return (
    <>

      {obligations.length > 0 && (
        <div
          className={`${page} ${identifier} home-records-table ${
            showMore ? "open" : ""
          }`}
          id={`record-box-${identifier}`}
        >
          <h2
            style={{
              color: "#333",
              textAlign: "left",
              paddingLeft: "1.563rem"
            }}
          >
            {title}
          </h2>
          {renderRecordTitles()}
          <div className="mainContent" id={`${identifier}-main-content`}>
            {obligations.length > 0 &&
              obligations
                .slice(
                  0,
                  showMore ? itemsToShow : numberOfLessObligationsToShow
                )
                .map(o => {
                  if (user?.role === "assignedUser" || o.user_id !== "0") {
                    const assignedUser = usersData
                      ? usersData.find(u => u._id === o.user_id) 
                      : [];

                    const userName = user?.role === "assignedUser"
                      ? user?.firstName + " " + user?.lastName
                      : assignedUser?.firstName + " " + assignedUser?.lastName
                    return (
                      <RecordComplex
                        type={type}
                        obligation={o}
                        key={o._id}
                        userNameText={
                          userName
                        }
                        users={
                          user?.role !== "assignedUser" && usersData
                            ? Array.isArray(usersData)
                              ? usersData.filter(
                                  u =>
                                    u.role === "assignedUser" ||
                                    u.role === "corporateComplianceAssessor"
                                )
                              : []
                            : []
                        }
                      />
                    );
                  } else {
                    return (
                      <RecordComplexWithAssign
                        type={type}
                        obligation={o}
                        key={o._id}
                        users={
                          Array.isArray(usersData)
                            ? usersData.filter(
                                u =>
                                  u.role === "assignedUser" ||
                                  u.role === "corporateComplianceAssessor"
                              )
                            : []
                        }
                      />
                    );
                  }
                })}
          </div>
          <div
            className={`footer home-records-table-footer ${showMore ? "open" : "closed"}`}
            id={`${identifier}-footer`}
          >
            <button
              id={`view-more-${identifier}`}
              className="viewMoreButton"
              disabled={obligations?.length <= numberOfLessObligationsToShow}
              onClick={handleClick}
            >
              {showMore ? "Show Less" : "Show More"}
            </button>
          </div>
        </div>
      )}
    </>
  );
};
